export default {
  tipo: {
    residenza: 0,
    domicilio: 1,
    residenza_domicilio: 2
  }
}